import React from 'react';
import { Parallax, ParallaxLayer } from '@react-spring/parallax';
import './App.css'; // You will add styles here in Step 4
import ConfettiModalWidget from "./ConfettiComponent"

export interface ChildProps {
  CompToRender: React.ReactNode; 
  CompToRender2: React.ReactNode;
  imageSrc: string;
}
const timelinepic = "./images/AQW-timeline2.png";
const horsefeatures = "./images/horse-blue.png"
const features = "./images/layout.png"
const integrityfish = "./images/fish-solid.png";
const plan1 = "./images/StatusPage1.png";
const plan2 = "./images/StatusPage2.png";
const divsectionheight = 1 //factor: proportion of viewport
const speedSlowBg = 0.2   //speed
const speedFastFg = 1.2   //speed

const MyParallaxContainer: React.FC<ChildProps> = ({ CompToRender, CompToRender2, imageSrc }) => {
  return (

    // The main container for the parallax effect, spanning 3 full screens
    // add style={{ top: '0', left: '0' }}  after pages={3} for starting from top of site
    <Parallax pages={4.5} style={{ left: '0', top: '0', backgroundColor: '#424045' }}>

      {/*////////////////////////////////// TIMELINE ////////////////////////////////*/}
      {/* Layer 1: Background for 0 element for the first page */}
      <ParallaxLayer
        factor={1.0}// This layer will be 1.5 times the height of the viewport
        offset={0} // Starts at the beginning of the first page
        speed={speedSlowBg} // Moves slower than the foreground (speed < 1)
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <div id="road-timeline" >
          <div className="center-content" style={{ margin: 'auto' }}>
            <h1 style={{ fontSize: '58px' }}>AquaWARE ROADMAP </h1>
          {/* Your background content (e.g., an image or color) <h1>Page One Background (Slow)</h1> 
            <img src={timelinepic} style={{ width: '80%', marginTop: '77px' }} alt="timeline" />*/}
          </div>
        </div>
      </ParallaxLayer>

      {/* Layer 2: Foreground for 0  content for the first page */}
      <ParallaxLayer
        factor={1.0}// This layer will be 1.5 times the height of the viewport
        offset={0}
        speed={speedFastFg} // Moves faster than the background (speed > 1)
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >

      </ParallaxLayer>
      

      {/*////////////////////////////////// GOALS ////////////////////////////////*/}

      {/* Layer 1: Background element for the first page */}
      <ParallaxLayer
        factor={divsectionheight}// This layer will be 1.5 times the height of the viewport
        offset={1.0} // Starts at the beginning of the first page
        speed={speedSlowBg} // Moves slower than the foreground (speed < 1)
        style={{
          backgroundColor: 'rgba(252, 206, 99, 0.5)',
          opacity: '1',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
      }}
      > 
        <div >
          {/* Your background content (e.g., an image or color) <h1>Page One Background (Slow)</h1> */}
          
        </div>
      </ParallaxLayer>

      {/* Layer 2: Foreground content for the first page */}
      <ParallaxLayer
        factor={divsectionheight}// This layer will be 1.5 times the height of the viewport
        offset={1.0}
        speed={speedFastFg} // Moves faster than the background (speed > 1)
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'  }}
      >
        <div id="road-goals" style={{ position: 'relative', width: '100%', margin: 'auto' }}>
          <div className='metric-card'>
            <h3 style={{ textAlign: 'center', fontStyle: 'italic', fontSize: '58px', color:'white'}}
            >GOALS FOR 2026-2031</h3>
            <br></br>
            <div style={{ width: '20%', margin: 'auto' }}>
              <hr className='small-line' style={{ color: 'white' }}></hr>
            </div>

            <h3 className='final-line-text-quote' style={{ fontStyle: 'italic', fontSize: '27px' }}> AquaWARE&trade; </h3>
          </div>
          <img src={integrityfish} className="round-image-with-shadow" style={{ position: 'absolute', zIndex: '2', width: '8%', bottom: '105%', left: '47% ', 
            transform: 'translateX(-50%, -50%)', opacity: '100%' }} alt="timeline" />
        </div>
        
      </ParallaxLayer>

      {/*////////////////////////////////// FEATURES - FUNCTIONALITIES - MODULES ////////////////////////////////*/}

      {/* Layer 3: Content for the second page */}
      {/*Background 2*/}
      <ParallaxLayer
        offset={2.0} // Starts at the beginning of the second page
        speed={speedSlowBg}
        style={{
          backgroundColor: '#424045', opacity:'0.2', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <div >
          
        </div>
      </ParallaxLayer>
      {/*Foreground 2*/}
      <ParallaxLayer
        factor={divsectionheight}// This layer will be 1.5 times the height of the viewport
        offset={2.0} // Starts at the beginning of the second page
        speed={speedFastFg}
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >

        <div id="road-features"  className='center-content'  >
          <div className='center-content' >
            <div>
              <h1>MAIN FEATURES</h1>
            </div>
            <div style={{ fontSize: '20px', textAlign: 'center', marginTop: '1.3em', marginBottom: '1.3em' }}>

              |	Currently working topics for immediate release
              | Preparation of BF2
              | Readiness for other potential clients

            </div>
            <div style={{ width: '60%', margin: 'auto' }}>
              <div className='App-3grid-container'>
                <div className='metric-card'>
                  <h3 style={{ textAlign: 'center', fontStyle: 'italic' }}
                  >AquaWARE - integrity</h3>
                  <br></br>
                  <div style={{ width: '20%', margin: 'auto' }}>
                    <hr className='small-line'></hr>
                  </div>
                  <br></br>
                  <p>Searas Proprietary <strong><em>cloud architecture</em></strong> to store fish farming big data, and automatic logging processes,
                    <a
                      className="App-link-sublte"
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.searas.no/aquasense"
                    > AquaBANK&trade;</a>
                  </p>
                  <p>Searas Proprietary software for <strong><em>data visualization</em></strong> and <strong><em>analysis</em></strong>,
                    automatic reporting, forecast and operational support,
                    <a
                      className="App-link-sublte"
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.searas.no/aquasense"
                    > AquaWARE&trade;</a>
                  </p>
                  <p>Searas’ Integral set of solutions: Handling System and Data Management </p>
                  <br></br>
                  <br></br>
                  <h3 className='final-line-text-quote'>SOFTWARE</h3>
                </div>
                <div className='metric-card'>
                  <h3 style={{ textAlign: 'center', fontStyle: 'italic' }}
                  >AquaWARE - cloud</h3>
                  <br></br>
                  <div style={{ width: '20%', margin: 'auto' }}>
                    <hr className='small-line'></hr>
                  </div>
                  <br></br>
                  <p><strong><em>Technical support</em></strong>, consulting services with
                    <a
                      className="App-link-sublte"
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.searas.no/aquasense"
                    >  AquaCARE&trade;</a>
                  </p>
                  <p>Simulations on demand (feed, growth, alkalinity, FCR...)</p>
                  <p>Technical reports</p>
                  <p>Monitoring control center with
                    <a
                      className="App-link-sublte"
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.searas.no/aquasense"
                    > AquaSENSE&trade;</a>
                  </p>
                  <br></br>
                  <br></br>
                  <h3 className='final-line-text-quote'>DATA STORAGE</h3>
                </div>
                <div className='metric-card'>
                  <h3 style={{ textAlign: 'center', fontStyle: 'italic' }}
                  >AquaCARE - deliverables</h3>
                  <br></br>
                  <div style={{ width: '20%', margin: 'auto' }}>
                    <hr className='small-line'></hr>
                  </div>
                  <br></br>
                  <p><strong><em>Technical support</em></strong>, consulting services with
                    <a
                      className="App-link-sublte"
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.searas.no/aquasense"
                    >  AquaCARE&trade;</a>
                  </p>
                  <p>Simulations on demand (feed, growth, alkalinity, FCR...)</p>
                  <p>Technical reports</p>
                  <p>Monitoring control center with
                    <a
                      className="App-link-sublte"
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.searas.no/aquasense"
                    > AquaSENSE&trade;</a>
                  </p>
                  <br></br>
                  <br></br>
                  <h3 className='final-line-text-quote'>SUPPORT</h3>
                </div>
                <div className='metric-card'>
                  <h3 style={{ textAlign: 'center', fontStyle: 'italic' }}
                  >Integration</h3>
                  <br></br>
                  <div style={{ width: '20%', margin: 'auto' }}>
                    <hr className='small-line'></hr>
                  </div>
                  <br></br>
                  <p><strong><em>Technical support</em></strong>, consulting services with
                    <a
                      className="App-link-sublte"
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.searas.no/aquasense"
                    >  AquaCARE&trade;</a>
                  </p>
                  <p>Simulations on demand (feed, growth, alkalinity, FCR...)</p>
                  <p>Technical reports</p>
                  <p>Monitoring control center with
                    <a
                      className="App-link-sublte"
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.searas.no/aquasense"
                    > AquaSENSE&trade;</a>
                  </p>
                  <br></br>
                  <br></br>
                  <h3 className='final-line-text-quote'>IT SOLUTIONS</h3>
                </div>
                <div className='metric-card'>
                  <h3 style={{ textAlign: 'center', fontStyle: 'italic' }}
                  >AquaWARE - sync</h3>
                  <br></br>
                  <div style={{ width: '20%', margin: 'auto' }}>
                    <hr className='small-line'></hr>
                  </div>
                  <br></br>
                  <p><strong><em>AquaWARE&trade; everywhere</em></strong>
                  </p>
                  <p>Annotations <em>in situ, initiate reports, insert relevant data</em></p>
                  <p>Simplied version for mobile devices, for data visualization and reporting</p>
                  <p>Portable production tools</p>
                  <br></br>
                  <br></br>
                  <h3 className='final-line-text-quote'>MOBILE APP</h3>
                </div>
                
                <div className='metric-card'>
                  <h3 style={{ textAlign: 'center', fontStyle: 'italic' }}
                  >Research projects</h3>
                  <br></br>
                  <div style={{ width: '20%', margin: 'auto' }}>
                    <hr className='small-line'></hr>
                  </div>
                  <br></br>
                  <p><a
                    className="App-link-sublte"
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.searas.no/aquasense"
                  > AquaNODE&trade; </a>
                    (biomass estimation, feed optimization)
                  </p>
                  <p>i-RAS, autopilot for
                    <a
                      className="App-link-sublte"
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.optiras.no"
                    > OptiRAS&trade;</a>
                  </p>
                  <p>ML for predictive analysis and forecast</p>
                  <p>Smart Alarm System</p>
                  <p>Hydraulics</p>
                  <br></br>
                  <br></br>
                  <h3 className='final-line-text-quote'>R&D</h3>
                </div>
              </div>
            </div>
          </div>
          <img src={features} className="round-image-with-shadow" style={{
            position: 'absolute', zIndex: '2', width: '8%', bottom: '105%', left: '47% ',
            transform: 'translateX(-50%, -50%)', opacity: '100%'
          }} alt="timeline" />
        </div>
      </ParallaxLayer>

      {/*////////////////////////////////// PLANNING ////////////////////////////////*/}

      {/* Layer 4: Content for the third page */}
      {/*Background 3*/}
      <ParallaxLayer
        factor={divsectionheight}// This layer will be 1.5 times the height of the viewport
        offset={3.0} // Starts at the beginning of the third page
        speed={speedSlowBg}
        style={{
          backgroundColor: '#40BED4', opacity: '0.5', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <div >
          
        </div>
      </ParallaxLayer>
      {/*Foreground 3*/}
      <ParallaxLayer
        factor={divsectionheight}// This layer will be 1.5 times the height of the viewport
        offset={3.0} // Starts at the beginning of the second page
        speed={speedFastFg}
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <div id="longterm" className='center-content' >
          <div>
            <h1>PLANNING</h1>
            {/* <img src={plan1} style={{ width: '60%', marginTop: '77px' }} alt="planning1" />
            <img src={plan2} style={{ width: '60%', marginTop: '77px' }} alt="planning2" /> */}
          </div>

          <ConfettiModalWidget />
          <p>Foreground Content (Fast)</p>
        </div>
        <img src={horsefeatures} className="round-image-with-shadow" style={{
          position: 'absolute', zIndex: '2', width: '8%', bottom: '105%', left: '47% ',
          transform: 'translateX(-50%, -50%)', opacity: '100%'
        }} alt="timeline" />
      </ParallaxLayer>
    </Parallax>
  );
};

export default MyParallaxContainer;